// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"fd76e039","885":"844ce30c","977":"6bcd25eb"}[chunkId] + ".chunk.js";
};